import React, { useEffect, useState, useContext } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Typography,
  Button,
  Upload,
  Card,
  message,
  Icon,
} from "antd";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";
import { withRouter } from "react-router-dom";
import Department from "../../../../assets/Department.svg";
import Employee from "../../../../assets/Employee.svg";
import Financier from "../../../../assets/Financier.svg";
import SalesTarget from "../../../../assets/sales-target.svg";
import Insurance from "../../../../assets/insurance.svg";
import Maintenance from "../../../../assets/maintenance.svg";
import Payment from "../../../../assets/payment-method-svgrepo-com.svg"
import Manufacturers from "../../../../assets/Manufacturers.svg";
import HSN from "../../../../assets/HSN.svg";
import SAC from "../../../../assets/SAC.svg";
import VehicleMaster from "../../../../assets/VehicleMaster.svg";
import VehiclePrice from "../../../../assets/VehiclePrice.svg";
import Accessories from "../../../../assets/Accessories.svg";
import Spareparts from "../../../../assets/Spareparts.svg";
import Jobcode from "../../../../assets/Jobcode.svg";
import SMS from "../../../../assets/SMS.svg";
import IDgenearator from "../../../../assets/IDgenearator.svg";
import RTO from "../../../../assets/rto.svg";
import Framenumber from "../../../../assets/Framenumber.svg";
import SupplierMaster from "../../../../assets/suppliermaster.svg";
import Whatsapp from "../../../../assets/whatsapp.svg";
import Uploads from "../../../../assets/upload.svg"
import Call from "../../../../assets/Call.svg"
import Address from "../../../../assets/Address.svg";

function CompanyMaster(props) {
  const { loginCredintials } = useContext(ContextAPI);

  const pageRoute = (param) => {
    props.history.push(`/autoadmin/${param}`);
  };
  function checkDropdownList(type) {
    let bool = false;
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        const sub = (each.subModule || "").toLowerCase().replace(/_/g, " ").trim();
        const target = type.toLowerCase().replace(/_/g, " ").trim();
        if ((sub === target || (target === "form 19" && (sub === "form 19" || sub === "form19"))) && each.access && each.access.read === true) {
          bool = true;
        }
      });
    }
    return bool;
  }

  return (
    <div style={{ background: "#f4f7fb", padding: "30px" }}>
      <Row gutter={26}>
        {checkDropdownList("department") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("department");
              }}
              // title="Department"
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Department
                  style={{ height: "70px", marginTop: "30px" }}
                ></Department>
              }
            >
              Department
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("employee") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("employee");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<Employee style={{ height: "70px", marginTop: "30px" }} />}
            >
              Employee
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("financier") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("financier");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Financier style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Financier
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("manufacturer") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("manufacturer");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Manufacturers style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Manufacturer
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("hsn") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("hsn");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<HSN style={{ height: "70px", marginTop: "30px" }} />}
            >
              HSN
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("sac") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("sac");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<SAC style={{ height: "70px", marginTop: "30px" }} />}
            >
              SAC
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("vehicle_master") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("vehicle_master");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <VehicleMaster style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Vehicle Master
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("service_schedule") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("service_schedule");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Jobcode style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Service Schedule
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("vehicle_price") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("vehicle_price");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <VehiclePrice style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Vehicle Price
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {/* {
          checkDropdownList('accessories') ?
            <Col span={6}>
              <Card
                style={{ cursor: 'pointer', marginTop: '20px' }}
                onClick={() => { pageRoute('accessories') }}
                bordered={true}
                bodyStyle={{ textAlign: 'center', fontSize: '16px', color: 'rgb(108, 123, 138)' }}
                cover={
                  <Accessories style={{ height: '70px', marginTop: '30px' }} />
                }
              >
                Accessories
              </Card>
            </Col>
            : <span></span>
        } */}
        {checkDropdownList("parts_master") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("parts_master");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Spareparts style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Parts Master
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("job_code") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("job_code");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<Jobcode style={{ height: "70px", marginTop: "30px" }} />}
            >
              Job Code
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {/* eslint-disable-next-line no-constant-condition */}
        {false ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("sms");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<SMS style={{ height: "70px", marginTop: "30px" }} />}
            >
              SMS
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {/* whatsup */}
        {checkDropdownList("whatsapp") && (
          <Col span={6}>
            <Card
              style={{ marginTop: "20px", cursor: "pointer" }}
              onClick={() => pageRoute("whatsup")}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Whatsapp
                  style={{
                    height: "70px",
                    marginTop: "30px",
                    color: "rgba(108, 123, 138, 0.863)",
                  }}
                />
              }
            >
              Whatsapp
            </Card>
          </Col>
        )}

        {checkDropdownList("supplier_master") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("supplier_master");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <SupplierMaster style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Supplier Master
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("idgenerator") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("idgenerator");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <IDgenearator style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              ID Generator
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("rtomaster") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("rtomaster");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={<RTO style={{ height: "70px", marginTop: "30px" }} />}
            >
              RTO Master
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("frame_number") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("frame_number");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Framenumber
                  style={{ height: "70px", marginTop: "30px", fill: "#006a71" }}
                />
              }
            >
              Frame Number
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("insurance") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("insurance");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Insurance
                  style={{ height: "70px", marginTop: "30px", fill: "#006a71" }}
                />
              }
            >
              Insurance Master
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("sales_targets") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("sales_targets");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <SalesTarget
                  style={{ height: "70px", marginTop: "30px", fill: "#006a71" }}
                />
              }
            >
              Sales Targets
            </Card>
          </Col>
        ) : (
          <span></span>
        )}
        {checkDropdownList("pmc") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("pmc");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Maintenance style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              PMC
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {/* upload */}

        {/* todo upload access have to check */}
        {checkDropdownList("upload") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("upload");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Uploads style={{ height: "70px", marginTop: "30px", fill: "gray" }} />
              }
            >
              Upload
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("Pine Labs") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("PineLabs");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Payment style={{ height: "70px", marginTop: "30px", fill: "gray" }} />
              }
            >
              PineLabs
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("SubDealer") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("SubDealer");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <SupplierMaster style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              SubDealer
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("bin_location") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("bin_location");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Department style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Bin Location
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("form_19") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("form_19");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <IDgenearator style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Form 19
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("country") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("country");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Address style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Country
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("state") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("state");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Address style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              State
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("city") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("city");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Address style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              City
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("district") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("district");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Address style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              District
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {checkDropdownList("locality") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("locality");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Address style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Locality
            </Card>
          </Col>
        ) : (
          <span></span>
        )}

        {/* {checkDropdownList("auto_caller") ? (
          <Col span={6}>
            <Card
              style={{ cursor: "pointer", marginTop: "20px" }}
              onClick={() => {
                pageRoute("auto_caller");
              }}
              bordered={true}
              bodyStyle={{
                textAlign: "center",
                fontSize: "16px",
                color: "rgb(108, 123, 138)",
              }}
              cover={
                <Call style={{ height: "70px", marginTop: "30px" }} />
              }
            >
              Auto Caller
            </Card>
          </Col>
        ) : (
          <span></span>
        )} */}

      </Row>
    </div>
  );
}

export default withRouter(CompanyMaster);
